export class Pais {
    constructor(
        public name: string,
        public value: number
    ) {}
}



// WEBPACK FOOTER //
// ./src/app/lib/model/pais.ts